<template>
  <div>
    <b-modal 
        id="modal-Equipment"
        :no-close-on-backdrop="true" 
        :title="`${!equipment.id ? 'Add' : 'Edit'} Equipment`" 
        hide-footer 
        centered 
        v-model="open"
        ref="modal-add-equipment">
        <b-form class="pb-20">
            <b-row >
                <template v-for="(item, index) in equipment.custom_fields">
                  <!-- <gofix-form-input label="tag" v-model="equipment.tag_name"></gofix-form-input> -->
                  <b-col md="6" :key="index" v-if="item.attribute.type === 'Free text' && (item.attribute.name === 'Lift No' || item.attribute.name === 'Lift Number')">
                      <gofix-form-input class="m-0"
                        :label="item.attribute.name" 
                        required
                        show-icon-required
                        v-model="item.value" 
                        @input="updateTagName">
                      </gofix-form-input>
                  </b-col>
                </template>
                <b-col md="6">
                    <gofix-form-tree
                        label="Equipment Group"
                        :options="groups"
                        :load-options="loadOptionsGroup"
                        placeholder=""
                        v-model="objTemp.group"
                        :normalizer="normalizerGroup"
                        search-nested
                        disabled
                        valueFormat="object">
                    </gofix-form-tree>
                </b-col>
            </b-row>
            <gofix-form-properties
                valueFormat="object"
                label="Location"
                :contract-id="ClientContractID && ClientContractID.id ? ClientContractID.id : null"
                disabled
                v-model="objTemp.location">
            </gofix-form-properties>
        </b-form>

        <b-button-group class="d-block text-right">
            <gofix-button v-if="equipment.id" label="DELETE" @click="modals.confirm.open = true" :disabled="!this.$checkRole(this.$accessModule.safety_app_location, 'delete')" noBorder></gofix-button>
            <gofix-button label="SUBMIT" @click="save" :disabled="!$checkRole(this.$accessModule.safety_app_location, 'update')" noBorder></gofix-button>
        </b-button-group>
    </b-modal>

    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
      <div class="center">Are you sure you want to <br/>delete <strong>This Equipment</strong>?</div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="modals.confirm.open = false">Cancel</b-button>
        <b-button class="custom-btn" @click="deleteEquipment" :disabled="modals.confirm.loading">
            <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner>Confirm
        </b-button>
      </b-button-group>
    </b-modal>
  </div>
</template>
<script>
import {LOAD_CHILDREN_OPTIONS} from "@riophae/vue-treeselect";
import { mapGetters } from 'vuex';

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500);
};
export default {
  name: 'modal-add-equipment-for-safety-app',
  components: {},
  props: {
    value: {
      required: false,
      default: null
    },
    treeSelected: {
      type: Object,
      required: false,
      default: {
        location: null
      }
    },
    info: {
      type: Object,
      required: false,
      default: {}
    },
  },
  data() {
    return {
      open: this.value,
      loading: false,
      groups: [],
      brands: [],
      models: [],
      timer: {
        brand: null,
        model: null
      },
      objTemp: {
        group: null,
        // brand: null,
        // model: null,
        location: null
      },
      equipment: {
        id: null,
        tag_name: null,
        equipment_type: null,
        equipment_group_id: null,
        brand: null,
        brand_id: null,
        model: null,
        model_id: null,
        location: null,
        location_id: null,
        serial_number: null,
        is_active: true,
        custom_fields: [],
        contract_id: null,
      },
      modals:{
        confirm: {
          open: false,
          loading: false
        },
      },
      timer: {
        delete: null
      }
    };
  },
  computed: {
    ...mapGetters({
      ClientContractID: 'ContractController/ClientContractID',
    })
  },
  watch: {
    value: function (val) {
      this.open = val;
    },
    open: function (val) {
      this.$emit("input", val);
      if (val) {
        this.objTemp.location = this.treeSelected && this.treeSelected.location ? this.treeSelected.location : null
        this.equipment = Object.assign(this.equipment, {
          id: null,
          tag_name: null,
          location: null,
          location_id: null,
          serial_number: null,
          is_active: true,
          contract_id: this.ClientContractID.id,
          brand: null,
          brand_id: null,
          model: null,
          model_id: null,
        });

        if(this.info.id) {
          this.equipment = Object.assign(this.equipment, {
            id: this.info.id,
            tag_name: this.info.tag_name,
            equipment_type: this.info.equipment_type,
            equipment_group_id: this.info.equipment_group_id,
            location: this.info.location_info,
            location_id: this.info.location_id,
            serial_number: this.info.serial_number,
            is_active: this.info.is_active,
            custom_fields: this.info.custom_fields,
            contract_id: this.info.contract_id,
            brand: this.info.brand,
            brand_id: this.info.brand_id,
            model: this.info.model,
            model_id: this.info.model_id,
          });
          
          this.objTemp = {
            group: {
              id: this.equipment.equipment_group_id,
              name: this.equipment.equipment_type
            },
            location: this.equipment.location,
          };
        } else {
          if(this.objTemp.group && this.objTemp.group.id) {
            this.getCustomFields(this.objTemp.group.id);
          }
        }
        
        /*this.getEquipmentBrand();
        this.getEquipmentModel();*/
      }
    },
    "objTemp.group": function (val) {
      if(this.equipment.id) return;
      this.equipment.equipment_type = null;
      this.equipment.equipment_group_id = null;
      if (val && val.id) {
        this.equipment.equipment_type = val.name;
        this.equipment.equipment_group_id = val.id;
        this.getCustomFields(val.id);
      }
    },
    /*"objTemp.brand": function (val) {
      this.models = [];
      this.objTemp.model = null;
      this.equipment.brand = null;
      this.equipment.brand_id = null;
      if (val) {
        this.equipment.brand = val.name ? val.name : null;
        this.equipment.brand_id = val.id ? val.id : null;
        if(val.id) {
          this.getEquipmentModel();
        }
      }
    },
    "objTemp.model": function (val) {
      this.equipment.model = null;
      this.equipment.model_id = null;
      if (val) {
        this.equipment.model = val.name ? val.name : null;
        this.equipment.model_id = val.id ? val.id : null;
      }
    },*/
    "objTemp.location": function (val) {
      if(this.equipment.id) return;
      this.equipment.location = null;
      this.equipment.location_id = null;
      if (val && val.id) {
        this.equipment.location = val.name;
        this.equipment.location_id = val.id;
      }
    }, 
    ClientContractID: function(val) {
      if(val && val.id) {
        this.getEquipmentGroups();
      }
    }
  },
  created() {
    if(this.ClientContractID && this.ClientContractID.id) {
      this.getEquipmentGroups();
    }
  },
  methods: {
    updateTagName(val) {
      this.equipment.tag_name = null;
      if(val)
        this.equipment.tag_name = `SafetyApp-${this.equipment.location_id}-${val}`;
    },
    save() {
      if (!this.equipment.tag_name) {
        return this.$alertNotification('Lift No is a required field.', 'danger');
      }

      if (!this.equipment.equipment_group_id) {
        return this.$alertNotification('Equipment group is a required field.', 'danger');
      }

      if (!this.equipment.location_id) {
        return this.$alertNotification('Loacation is a required field.', 'danger');
      }

      let params = JSON.parse(JSON.stringify(this.equipment));
      params.custom_fields = params.custom_fields ? JSON.stringify(params.custom_fields) : null;
      delete params.location;

      this.$store.dispatch('EquipmentV2Controller/saveEquipment', params)
        .then(result => {
          this.open = false;
          this.$alertNotification(this.$notificationV2(this.equipment.id ? 'editing' : 'adding', 'equipment'));
          this.$emit('reloadList');
        })
        .catch(err => {
          console.log(err)
          this.$alertNotification(err.response.data.error.message.error, "danger");
        })
    },
    async deleteEquipment(){
      if(!this.equipment.id) return;
      if (this.timer.save) {
        clearTimeout(this.timer.save);
        this.timer.save = null;
      }
      this.timer.save = setTimeout(() => {
        if(this.modals.confirm.loading) return
        this.modals.confirm.loading = true

        this.$store.dispatch("EquipmentV2Controller/deleteEquipment", [this.equipment.id])
        .then(response => {
          this.modals.confirm.loading = this.modals.confirm.open = this.open = false;
          this.$emit('reloadList');
          this.$alertNotification(this.$notificationV2('deleting', 'equipment'));
        })
        .catch(err => {
          this.modals.confirm.loading = false;
        });
      }, 200);
    },
    /*--- Equipment Group ---*/
    normalizerGroup(node) {
      if (node.isBatch)
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      return {
        id: node.id,
        label: node.name,
        children: undefined,
      };
    },
    loadOptionsGroup({action, parentNode, callback}) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        if (parentNode.children) {
          parentNode.children = parentNode.children;
          callback();
          return;
        }
        if (parentNode.isBatch) {
          this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
            id: parentNode.data.id,
            contract_id: this.ClientContractID.id
          })
              .then(response => {
                simulateAsyncOperation(() => {
                  parentNode.children = response.data.data;
                  callback();
                });
              });
        } else {
          parentNode.children = [];
          callback();
        }
      }
    },
    getEquipmentGroups() {
      this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
        id: 0,
        contract_id: this.ClientContractID.id
      }).then(response => {
        this.groups = response.data.data;
        if(this.groups && this.groups.length && this.groups[0].children && this.groups[0].children.length > 0) {
          let filtered = this.groups[0].children.filter(item => {
            return item.name.toLowerCase() === 'lift';
          });
          if(filtered && filtered.length > 0) {
            this.objTemp.group = filtered[0];
          }
          this.$emit('groupSelected', this.objTemp.group ? true : false);
        }
      });
    },
    /*--- Equipment Brand ---*/
    /*async getEquipmentBrand(search = '') {
      await this.$store.dispatch("MasterBrandController/getItems", {
        limit: 100,
        sortColumn: "name",
        sortDirection: "ASC",
        filter: {
          name: search,
          contract_id: this.$route.params.id,
        }
      })
          .then(response => {
            this.brands = response.items;
            if (!this.brands.length && search) {
              this.objTemp.brand = {id: 0, name: search};
            }
          });
    },
    searchEquipmentBrand(search, loading) {
      loading(true);
      this.brands = []
      if (this.timer.brand) {
        clearTimeout(this.timer.brand);
        this.timer.brand = null;
      }
      this.timer.brand = setTimeout(async () => {
        try {
          await this.getEquipmentBrand(search);
          await loading(false);
        } catch (err) {
          loading(false);
        }
      }, 300);
    },*/
    /*--- Equipment Model ---*/
    /*async getEquipmentModel(search = '') {
      if (!this.equipment.brand_id) {
        if(search) this.objTemp.model = {id: 0, name: search, type_brand_id: this.equipment.brand_id};
        return;
      }

      await global.axios(`api/equipment/models`, {
        method: "GET",
        params: {
          type_brand_id: this.equipment.brand_id,
          search: search
        },
        headers: {
          Accept: "application/json"
        }
      })
          .then(response => {
            this.models = response.data.data;
            if (!this.models.length && search) {
              this.objTemp.model = {id: 0, name: search, type_brand_id: this.equipment.brand_id};
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    searchEquipmentModel(search, loading) {
      loading(true);
      this.equipmentModel = []
      if (this.timer.model) {
        clearTimeout(this.timer.brand);
        this.timer.model = null;
      }
      this.timer.model = setTimeout(async () => {
        try {
          await this.getEquipmentModel(search);
          await loading(false);
        } catch (err) {
          loading(false);
        }
      }, 300);
    },*/
    /*--- Custom Fields ---*/
    getCustomFields(equipment_group_id) {
      this.equipment.custom_fields = [];
      this.$store.dispatch('EquipmentV2Controller/getCustomFields', {
        equipment_group_id: equipment_group_id,
      })
          .then(response => {
            this.equipment.custom_fields = response;
          })
          .catch(err => {
            console.log(err);
          })
    }
  }
}
</script>
